// eslint-disable-next-line import/prefer-default-export
export enum UPLOAD_ERROR {
    GENERAL = 'general',
    FILESIZE = 'filesize',
    FILETYPE = 'filetype',
    OTHER = 'other',
}
